import { ConfirmationDialog } from "portal/components/ConfirmationDialog";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

interface UnsavedChangesDiscardDialogProps {
  onClose: () => void;
  onYes: () => void;
}

export const UnsavedChangesDiscardDialog: FC<
  UnsavedChangesDiscardDialogProps
> = ({ onClose, onYes }) => {
  const { t } = useTranslation();
  return (
    <ConfirmationDialog
      title={t("components.unsavedChanges.title")}
      description={t("components.unsavedChanges.description")}
      destructive
      yesText={t("utils.actions.discard")}
      noText={t("utils.actions.close")}
      showCloseButton
      onClose={onClose}
      onYes={onYes}
    />
  );
};
